module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "correct"
  }, [(_vm.myAnswerAmount.todayAmount) ? _c('div', [_c('div', {
    staticClass: "hb"
  }, [_c('p', [_vm._v("¥" + _vm._s(_vm.myAnswerAmount.todayAmount))])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("恭喜，红包到手")]), _vm._v(" "), _c('div', {
    staticClass: "look_div"
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("您已累计获得")]), _vm._v(" "), _c('span', {
    staticClass: "s2"
  }, [_vm._v(_vm._s(_vm.myAnswerAmount.scoreAmount) + " 元")]), _vm._v(" "), _c('x-button', {
    staticClass: "look_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toMyredpacket.apply(null, arguments)
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('p', {
    staticClass: "p1",
    staticStyle: {
      "font-size": "0.3733rem",
      "margin-top": "0.8rem"
    }
  }, [_vm._v("\n      可喜可贺，额外获赠两个友情红包\n    ")]), _vm._v(" "), _c('x-button', {
    staticClass: "invitation_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toast.apply(null, arguments)
      }
    }
  }, [_vm._v("转赠好友")])], 1) : _c('div', {
    staticClass: "no_money"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.yxvzb.com/WEB/images/answergold120.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("今日红包已领完")]), _vm._v(" "), _c('p', [_vm._v("请您明日再来")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "getHbs",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.bestToday.length) ? _c('ul', {
    ref: "box",
    staticClass: "ul_box",
    style: ({
      transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"),
      transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms"),
    })
  }, _vm._l((_vm.bestToday), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "h_s1"
    }, [_vm._v(_vm._s(_vm._f("transHours")(item.createTime)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2.5rem:text-align:left"
      }
    }, [_c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "h_s2"
    }, [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])
  }), 0) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right_img_top"
  }, [_c('p', [_vm._v("今日手气最佳")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6a352cdd"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/CorrectEntry/index.vue
// module id = 240
// module chunks = 1